import styled from 'styled-components';

export const FilterText = styled.div`
  font-size: 1.0rem;
`;